import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { parse } from "query-string";

import { getStore } from "./Services/Api";
import Loading from "./Components/Loading";
import DashboardPage from "./Views/Dashboard";
import ConfigEstablishmentPage from "./Views/ConfigEstablishment";
import ConfigAttendance from "./Views/ConfigAttendance";
import Plans from "./Views/Plans";
import Orders from "./Views/Orders";
import Checkout from "./Views/Checkout";
import DownloadBoletoView from "./Views/DownloadBoletoView";
import Account from "./Views/Account";

export default function Routes() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  if (search) {
    const { accessToken, isManager } = parse(search);
    if (accessToken) {
      localStorage.setItem("token", accessToken);
      window.location = "/";
    }
    if (isManager) {
      localStorage.setItem("isManager", isManager);
    } else {
      localStorage.removeItem("isManager");
    }
  }

  React.useEffect(() => {
    getStore()
      .then((store) => {
        dispatch({ type: "INIT_STORE", store });
      })

      .catch((err) => (window.location = "/#/login"));
  }, []);

  const isReady = useSelector((state) => state.store.loaded);

  if (!isReady) return <Loading />;

  return (
    <Switch>
      <Route exact path="/cardapio" component={DashboardPage} />
      <Route exact path="/establishment">
        <ConfigEstablishmentPage />
      </Route>
      <Route exact path="/attendance">
        <ConfigAttendance />
      </Route>
      <Route exact path="/account" component={Account} />
      <Route exact path="/plans" component={Plans} />
      <Route exact path="/orders" component={Orders} />
      <Route exact path="/checkout" component={Checkout} />
      <Route
        exact
        path="/subscription/download-boleto"
        component={DownloadBoletoView}
      />
      <Redirect exact path="/" to="/cardapio" />
    </Switch>
  );
}
